"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firebaseFailureCodes = void 0;
exports.firebaseFailureCodes = {
    permissionDenied: 'permission-denied',
    needLogin: 'auth/requires-recent-login',
    tooManyRequests: 'auth/too-many-requests',
    wrongPassword: 'auth/wrong-password',
    userNotFound: 'auth/user-not-found',
    authInternalError: 'auth/internal-error',
    popupClosedByUser: 'auth/popup-closed-by-user',
    emailAlreadyInUse: 'auth/email-already-in-use',
    emailAlreadyExists: 'auth/email-already-exists',
    cancelledPopupRequest: 'auth/cancelled-popup-request',
    notificationsBlocked: 'messaging/notifications-blocked',
    storageCancelled: 'storage/canceled',
    objectNotFound: 'storage/object-not-found',
    unavailable: 'unavailable',
    registrationTokenNotRegistered: 'messaging/registration-token-not-registered',
    messagingMismatchedCredential: 'messaging/mismatched-credential',
    messagingTokenSubscribeFailed: 'messaging/token-subscribe-failed',
};
